import PropTypes from 'prop-types';
import cssVariables from 'src/common/styles/variables';

/* eslint-disable max-len */
const HeartBrokenIcon = ({
  width,
  height,
  viewBox,
  onClick,
  className,
  dataTestId,
  fill,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox || '0 0 24 24'}
    fill={fill || cssVariables['--tunein-coral']}
    className={className}
    data-testid={dataTestId}
    onClick={onClick}
  >
    <defs>
      <clipPath id="clip-Unfavorite">
        <rect width="24" height="24" />
      </clipPath>
    </defs>
    <g id="Unfavorite" clipPath="url(#clip-Unfavorite)">
      <path
        id="Path_1200"
        data-name="Path 1200"
        d="M662.82,1206.25l12.37,12.37-2.59,2.7a.543.543,0,0,1-.78,0l-7.98-8.3A6,6,0,0,1,662.82,1206.25Zm17.75-1.47a4.851,4.851,0,0,0-6.86-.17c-.06.05-.12.11-.18.17l-1.32,1.41-1.33-1.41a4.818,4.818,0,0,0-3.52-1.52v.03c-.14,0-.28.01-.41.02l11.7,11.71,1.92-2A6.008,6.008,0,0,0,680.57,1204.78Zm-18.716-1.612,19.172,19.172a.5.5,0,0,0,.707,0l.707-.707a.5.5,0,0,0,0-.707l-19.172-19.173a.5.5,0,0,0-.707,0l-.707.707A.5.5,0,0,0,661.854,1203.168Z"
        transform="translate(-660.208 -1200.107)"
        fill="#fd685f"
        fillRule="evenodd"
      />
    </g>
  </svg>
);

HeartBrokenIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  fill: PropTypes.string,
  onClick: PropTypes.func,
};

export default HeartBrokenIcon;
